import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_NAME = 'LXRA Studios';
const DEFAULT_DESCRIPTION = 'Cinematic photography & videography studio serving the DMV (Washington DC, Maryland & Virginia). Portraits, events, graduations, automotive & more.';
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1617901883714-151853555aa8?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80';

// Per-page SEO + Open Graph / Twitter card meta tags, canonical link, and
// optional JSON-LD structured data (e.g. LocalBusiness, Article schema) for
// richer Google results. Canonical/og:url default to the current route on
// whatever domain the app is served from, so it adapts automatically when a
// custom domain replaces the preview URL — no hardcoding needed.
export const SEO = ({ title, description = DEFAULT_DESCRIPTION, image = DEFAULT_IMAGE, url, structuredData }) => {
  const { pathname } = useLocation();
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} \u2014 Cinematic Photography & Videography`;
  const canonicalUrl = url || (typeof window !== 'undefined' ? `${window.location.origin}${pathname}` : undefined);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </Helmet>
  );
};
